// Base scopes requested during initial authentication
export const BASE_SCOPES = [
  'User.Read',
  'Calendars.Read',
  'OnlineMeetings.Read',
  'email',
  'openid',
  'profile',
  'offline_access',
];

// All scopes including optional permissions (OneDrive, etc.)
// Used when re-requesting consent after a "consent-required" error
export const ALL_SCOPES = [
  ...BASE_SCOPES,
  'Files.ReadWrite.AppFolder',
];
